import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { convertCommissionSplitsValues } from "mappers";
import { commissionSplitsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetCommissionSplitQuery = ({
	agentId,
	commissionId,
}: {
	agentId: string;
	commissionId: string;
}) => {
	const dispatch = useDispatch();
	const queryResult = useQuery(
		["getCommissionSplit", commissionId],
		() =>
			commissionSplitsService.getCommissionSplitInfo(
				agentId,
				commissionId,
			),
		{
			select: commissionSplitInfo => {
				return convertCommissionSplitsValues(commissionSplitInfo);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetCommissionSplitQuery;
